import Icon from '../components/Icon.vue'

Icon.register({
  'door-open': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M624 448c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-144v-384h-96v-64h112c26.5 0 48 22.2 48 49.5v334.6h80zM312.2 1c20.2-5.2 39.8 10.6 39.8 32.2v478.8h-336c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h80v-365.1c0-15.2 10-28.5 24.2-32.2zM264 288c13.3 0 24-14.3 24-32s-10.8-32-24-32-24 14.3-24 32 10.8 32 24 32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/door-open.js
// module id = 1281
// module chunks = 0